import _ from 'lodash';
import {browserHistory} from 'react-router';

function toQuery(filter, pagination, sorting, defaultFilter) {
  const query = {};

  if (filter) {
    for (const pair of filter.entries()) {
      if (!pair[1]) continue;
      if (_.get(defaultFilter, pair[0]) === pair[1]) continue;

      query[`f-${pair[0]}`] = pair[1];
    }
  }

  if (sorting) {
    for (const pair of sorting.entries()) {
      if (!pair[1]) continue;

      query[`s-${pair[0]}`] = pair[1];
    }
  }

  if (pagination && pagination.currentPage > 1) {
    query['p'] = pagination.currentPage;
  }

  return query;
}

function saveStateToUrl(filter, pagination, sorting, defaultFilter) {
  const location = browserHistory.getCurrentLocation();
  const query = {...location.query};

  Object.keys(query).forEach(key => {
    if (key.startsWith('f-') || key.startsWith('s-') || key === 'p') {
      delete query[key];
    }
  });

  Object.assign(query, toQuery(filter, pagination, sorting, defaultFilter));

  location.query = query;
  browserHistory.replace(location);
}

export default saveStateToUrl;
